import styles from "../styles/Menu.module.css";
import WrapComponentMenu from "../components/Menu/WrapComponentMenu";
import React from "react";
import {useNavigate} from "react-router-dom";
const MenuPage = () =>{
    const navigate = useNavigate();
    const handleClick = () => {
        window.scrollTo(0, 0)
        navigate('/tisch-reservieren');
    }
    return (
        <>
            <section className={styles.heroContainer}>
                <div className={styles.overlay}>
                    <h1 className={styles.title}>Speisekarte</h1>
                </div>
            </section>
            <div>
                <WrapComponentMenu isHome={false} handleClick={handleClick}/>
            </div>
        </>
    )
}

export default MenuPage;